import { Component } from '@angular/core';
import { GenericCrudAddDocumentComponent } from 'src/app/libs/components/generic-crud/generic-crud-add-document/generic-crud-add-document.component';
import { IAddress, Project } from 'src/app/models';
import { HrCalendarsAddComponent } from 'src/app/routes/hr/hr-operative/hr-calendars/hr-calendars-add/hr-calendars-add.component';
import { HrTimetablesAddComponent } from 'src/app/routes/hr/hr-operative/hr-timetables/hr-timetables-add/hr-timetables-add.component';

@Component({
    selector: 'app-pms-projects-add',
    templateUrl: './pms-projects-add.component.html',
    styleUrl: './pms-projects-add.component.sass',
    standalone: false
})
export class PmsProjectsAddComponent extends GenericCrudAddDocumentComponent<Project>  {

  createTimetableComponent = HrTimetablesAddComponent;
  createCalendarComponent = HrCalendarsAddComponent;
  timetables = this.api.resources.timetables;
  calendar = this.api.resources.calendars;
  workers = this.api.resources.workers;

  override resource = this.api.resources.operations.projects;


  override initChildForm() {
    const address: IAddress = {
      address: '',
      city: '',
      postalCode: '',
      region: '',
      countryId: undefined as any,
    };

    this.form = this.fb.group({
      name: [undefined],
      calendarId: [undefined],
      timetableId:[undefined],
      projectManagerWorkerId: [undefined],
      initialBudget: [undefined],
      comments: [''],
      address: [address],
    });
  }

  override async mapFormEntity(): Promise<Project> {
    const project = this.form!.value as Project;
    project.companyId = this.api.auth.userValue!.lastCompanyId;
    this.storage.clearProjects();
    Object.assign(project, this.form!.value.address);
    
    if (project.countryId === undefined) {
      (project as any).countryId = null;
    }
    
    return project;
  }

  formatCurrency = (value: number | null) => {
    if (value === null)
      return '';

    return new Intl.NumberFormat('es-ES', { maximumFractionDigits: 20 }).format(value) + ' €';
  };
}
